import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import {
  useEstimateStructure,
  useSummaryTeamInputTooltipAlert,
  useVisibilityModeCellClassName,
  useEstimateEditorSettings,
  ValueCell
} from "@tools";
import useStyle from "../../TeamMembersCell.style"
import classnames from "classnames";

export const TeamMembersCell = observer(({
  element,
  displayCellContent,
  ...props
}) => {
  const { allowEdition, useProfitability } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  const tooltip = useSummaryTeamInputTooltipAlert(allowEdition);
  const className = useVisibilityModeCellClassName(structure.visibility.hideSummaryTeam);
  const classes = useStyle();
  
  const { displayAnyValue } = structure;
  const { displayTeamMembers, hasFixedPrice, hasResources } = element;
  
  const handleTeamMembersChange = (members) => {
    element.setTeamMembers(members);
  };

  return (
    <ValueCell
      size="medium"
      min={1}
      value={displayTeamMembers}
      emptyInputs={!displayAnyValue}
      onValueChange={handleTeamMembersChange}
      displayContent={!hasFixedPrice && displayCellContent}
      editable={allowEdition && !hasResources && !useProfitability}
      className={className}
      textPresetClass={classnames("preset-summaryText", classes.input)}
      inputClassName="input-team-members"
      { ...props }
      { ...tooltip }
    />
  );
});

TeamMembersCell.propTypes = {
  element: object.isRequired,
  displayCellContent: bool,
  extendPadding: bool,
};